export const EMAIL_TEMPLATE_KEYS = {
  all: ['email-templates'] as const,
  registry: ['email-templates', 'registry'] as const,
  locales: ['email-templates', 'locales'] as const,
  list: (filters?: object) => ['email-templates', 'list', filters ?? {}] as const,
  detail: (id: string) => ['email-templates', 'detail', id] as const,
  byTemplateLocale: (template: string, locale: string) =>
    ['email-templates', 'by', template, locale] as const,
  mock: (template: string) => ['email-templates', 'mock', template] as const,
};
